import React from "react";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";

const UserInfoModal = ({ info }) => {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <Button onClick={() => setOpen(true)}>View</Button>
      <Modal
        show={open}
        onHide={() => setOpen(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="contribution-modal"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            User Information
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column justify-content-left align-content-left p-4">
            <div>
              {info.map((item) => {
                if (!item.name.includes("File")) {
                  return (
                    <div key={item.name}>
                      {item.name} : {item.value.toString()}{" "}
                    </div>
                  );
                }
                return (
                  <div key={item.name}>
                    {" "}
                    {item.name} : {item.value}{" "}
                  </div>
                );
              })}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UserInfoModal;
